import { createDefaultWorksheet, Worksheet } from "./budgetCalculatorModel"
import API from '../api'

export const WorksheetsUrl = '/web/budgets/worksheets'
export const WorksheetsQueryKey = 'budget-worksheets'

export type WorksheetResponse = {
  title: string
  budgetWorksheetId: string
  data: string
  isApplied: boolean
}

export type WorksheetListItem = {
  title: string
  budgetWorksheetId: string
  isApplied: boolean
  appliedYear: number
  appliedAt: string | null
  updatedAt: string | null
}

export type WorksheetsResponseList = {
  worksheets: WorksheetListItem[]
}

export const getWorksheets = async (): Promise<WorksheetListItem[]> => {
  const data = (await API.get<WorksheetsResponseList>(WorksheetsUrl)).data
  return data.worksheets
}

export const saveWorksheet = async (worksheet: Worksheet) => {
    await API.post(WorksheetsUrl, { ...worksheet, data: JSON.stringify(worksheet.data) })
}

export const getWorksheetById = async (id: string | undefined): Promise<Worksheet> => {
  if (id === undefined) {
    return createDefaultWorksheet()
  }
  const response = (await API.get<WorksheetResponse>(`${WorksheetsUrl}/${id}`)).data
  return {
    budgetWorksheetId: response.budgetWorksheetId,
    title: response.title,
    data: JSON.parse(response.data),
    isApplied: response.isApplied,
    appliedAt: null
  }
}

export const copyWorksheetById = async (id: string, title: string): Promise<Worksheet> => {
  const response = (await API.post<WorksheetResponse>(`${WorksheetsUrl}/${id}/copy`, { title })).data
  return {
    budgetWorksheetId: response.budgetWorksheetId,
    title: response.title,
    data: JSON.parse(response.data),
    isApplied: response.isApplied,
    appliedAt: null
  }
}

export const deleteWorksheetById = async (id: string): Promise<void> => {
  await API.delete<WorksheetResponse>(`${WorksheetsUrl}/${id}`)
}